export default {
  data() {
    return {
      userPopUps: []
    }
  },
  methods: {
    getUser(callback = null) {
      this.request({
        url: this.endpoint("users/currentUser/"),
        method: "get",
        success: data => {
          this.$store.commit("setUser", data);

          // here check the user permissions

          this.userPopUps = this.user.pop_up_notifications;
          callback && callback();
        }
      });
    },
  },
}